
import { Profile } from '@/types/database.types';
import { UserCard } from './UserCard';

interface UserListProps {
  users: Profile[] | null;
  adminUsers: string[];
  getInitials: (firstName?: string | null, lastName?: string | null) => string;
  formatDate: (date: string) => string;
  onAdminStatusChange: () => void;
}

export const UserList = ({ 
  users, 
  adminUsers,
  getInitials, 
  formatDate,
  onAdminStatusChange
}: UserListProps) => {
  if (!users || users.length === 0) {
    return (
      <div className="col-span-full py-10 text-center">
        <p className="text-muted-foreground">No users found</p>
      </div>
    );
  }

  return (
    <>
      {users.map((user) => (
        <UserCard 
          key={user.id} 
          user={user} 
          isAdmin={adminUsers.includes(user.id)}
          getInitials={getInitials} 
          formatDate={formatDate}
          onAdminStatusChange={onAdminStatusChange}
        />
      ))}
    </>
  );
};
